export const LIVE_TICKER_PREVIEW_DEBOUNCE_MS = 400;

export const tickerPreviewEnabledForEnvironment = (nodeEnv) =>
  nodeEnv === "development";

export const tickerPreviewQueryForDraft = (draft) =>
  String(draft || "").trim();

export const normalizeTickerPreviewRows = (rows) => {
  if (!Array.isArray(rows)) return [];

  const seenTickers = new Set();
  return rows.filter((row) => {
    const id = row?.id == null ? "" : String(row.id);
    const ticker = row?.ticker == null ? "" : String(row.ticker).trim();
    const tickerKey = ticker.toUpperCase();
    if (!id || !ticker || seenTickers.has(tickerKey)) return false;
    seenTickers.add(tickerKey);
    return true;
  });
};

export const tickerPreviewRowsForEvent = (
  detail,
  activeThreadUuid,
  latestRequestId,
) => {
  if (detail?.threadUuid !== activeThreadUuid) return null;

  const preview = detail?.preview || {};
  if (
    String(preview.request_id || "") !==
    String(latestRequestId || "")
  ) {
    return null;
  }

  return normalizeTickerPreviewRows(preview.tickers);
};
